import { toRefs, computed } from 'vue';
import { getThemeColor, getThemeTextColor } from '../../styles/theme/component-lib.esm3.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';

//
var script = {
  name: 'Badge',
  props: {
    component: {
      type: String,
      default: 'span'
    },
    color: {
      type: String,
      default: 'primary'
    },
    content: {
      type: [String, Number],
      default: null
    },
    /**
     * 'floating' | 'inline' | 'attached'
     */
    variant: {
      type: String,
      default: 'inline'
    },
    dot: Boolean
  },
  setup(props) {
    const {
      color
    } = toRefs(props);
    const theme = useTheme();
    const styles = computed(() => {
      return {
        '--c-bg-color': getThemeColor(color.value, theme.value),
        '--c-color': getThemeTextColor(color.value, theme.value)
      };
    });
    const classes = computed(() => {
      return {
        [`v-badge--${props.variant}`]: !!props.variant,
        'v-badge--dot': props.dot
      };
    });
    return {
      styles,
      classes
    };
  }
};
export { script as default };